import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Do not prefix local asset files with API base URL
    if (req.url.startsWith('http') || req.url.includes('assets/')) {
      return next.handle(req);
    }
    return next.handle(req.clone({ url: `${environment.apiBaseUrl}${req.url}` }));
  }
}
